angular.module('Itao.IndicatorMap').directive('horizontalStackedSetBarChart', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var colors = [];
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var innerColor = accessor('color');

  var whiteToOpacity = function (d) {
    return d.color.toLowerCase() === '#ffffff' ? 0 : 1;
  };

  var offsetMappingFunction = function (propertyName) {
    return function (listObject, index, listArray) {
      // calculate the offset for each element in a list by the sum of the preceding elements
      listObject.offset = listArray.slice(0, index).reduce(function (sum, currentListObject) {
        return sum + currentListObject[propertyName];
      }, 0);
      return listObject;
    };
  };

  var sumMappingFunction = function (valuePropertyName, listPropertyName) {
    return function (listObject) {
      // only calculate sum if this has subElements
      if (listObject[listPropertyName] !== null) {
        // calculate the sum of a list by using the last offset and value
        var lastValue = listObject[listPropertyName][listObject[listPropertyName].length - 1];
        if (lastValue != null) {
          listObject.sum = lastValue.offset + lastValue[valuePropertyName];
        } else {
          listObject.sum = 0;
          console.warn('Last value in listObject not found:', listObject);
        }
      }

      if (listObject.sum < 99.99 && listObject.unit === "%") {
        listObject.nOffset = 100 - listObject.sum;
      }
      return listObject;
    };
  };

  var combineData = function (layer, selectedIndicatorSet, disabledDistrictKeys, disabledListIndex, colorset, legend) {
    var indicatorsWithoutLists = selectedIndicatorSet.indicators.filter(function (indicator) {
      return indicator.list === false;
    });

    var unit = indicatorsWithoutLists[0].unit;

    var listCount = 0;
    var listsAndIndicators = indicatorsWithoutLists
      .concat(selectedIndicatorSet.lists)
      .sort(function (a, b) {
        return a.listIndex - b.listIndex;
      })
      .map(function (listOrIndicator, index, allElements) {
        var subElementsCount = 0;
        if (listCount === 0 && listOrIndicator) {
          listOrIndicator.legendIndex = 0;
          listCount++;
        } else if (listOrIndicator) {
          if (allElements[listCount - 1].hasOwnProperty('indicators')) {
            subElementsCount = allElements[index - 1].indicators.filter(function (indicator) {
              return !!indicator;
            }).length;
          }
          listOrIndicator.legendIndex = allElements[listCount - 1].legendIndex + subElementsCount + 1;
          listCount++;
        }
        return listOrIndicator;
      });

    return Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function (districtUid) {
      var barIndex = -1;
      return {
        // first level: districts
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        listValues: listsAndIndicators.map(function (listOrIndicator, index) {
          // second level: indicatorLists
          var isList = listOrIndicator.hasOwnProperty('indicators');
          var subValues = null;
          var sum = 0;
          var prefix = isList ? (listOrIndicator.indicators[0] != null ? listOrIndicator.indicators[0].prefix : '') : listOrIndicator.prefix;
          barIndex++;

          var listOrIndicatorName = isList ? listOrIndicator.title : listOrIndicator.name;
          if (legend != null) {
            if (legend.chart.scales.hasOwnProperty(listOrIndicator.legendIndex)) {
              listOrIndicatorName = legend.chart.scales[listOrIndicator.legendIndex].text;
            } else {
              console.warn('Scale is missing index ' + listOrIndicator.legendIndex + ' using ' + listOrIndicatorName + ' instead.');
            }
          }

          var listCount = 0;
          if (isList) {
            // get values for every indicator in the list
            subValues = listOrIndicator.indicators.map(function (indicator, index) {
              barIndex++;
              if (!layer[districtUid].hasOwnProperty(indicator.uid)) {
                return null;
              }
              listCount++;
              // third level: values per indicator
              var valueLegendIndex = listOrIndicator.legendIndex + listCount;
              var value = 0;
              if (layer[districtUid][indicator.uid] != null) {
                value = (+layer[districtUid][indicator.uid]);
              }

              var valueName = indicator.name;
              if (legend != null) {
                if (legend.chart.scales.hasOwnProperty(valueLegendIndex)) {
                  valueName = legend.chart.scales[valueLegendIndex].text;
                } else {
                  console.warn('Scale is missing index ' + listOrIndicator.legendIndex + '. Using ' + valueName + ' instead.');
                }
              }

              return {
                value: value,
                unit: indicator.unit,
                prefix: indicator.prefix,
                offset: 0,
                name: valueName,
                idx: barIndex,
                color: colorset[valueLegendIndex % colorset.length],
                legendIndex: valueLegendIndex,
                key: indicator.key
              };
            }).filter(function (value) {
              return value !== null;
            }).map(offsetMappingFunction('value'))
          } else {
            // value for single indicator without list
            if (layer[districtUid].hasOwnProperty(listOrIndicator.uid)) {
              sum = (+layer[districtUid][listOrIndicator.uid]);
            } else {
              sum = null;
            }
          }

          return {
            isList: isList,
            name: listOrIndicatorName,
            key: listOrIndicator.key,
            uid: listOrIndicator.uid,
            prefix: prefix,
            sum: sum,
            unit: unit,
            offset: 0,
            idx: barIndex,
            legendIndex: listOrIndicator.legendIndex,
            color: colorset[listOrIndicator.legendIndex % colorset.length],
            values: subValues
          };
        }).filter(function (item, idx) {
          return disabledListIndex.indexOf(idx) === -1;
        }).filter(function (listOrIndicator) {
          return (listOrIndicator.isList === false && listOrIndicator.sum !== null) || (listOrIndicator.isList && listOrIndicator.values.length > 0);
        }).map(sumMappingFunction('value', 'values'))
          .map(offsetMappingFunction('sum'))
          .map(function (listOrIndicator) {
            // add empty array for values in indicator
            if (!listOrIndicator.isList) {
              listOrIndicator.values = [];
            }
            return listOrIndicator;
          })
      };
    }).map(sumMappingFunction('sum', 'listValues'));
  };

  var horizontalStackedSetBarChart = function () {
    var indicators = [],
      svgHeight = 200,
      margin = {top: 40, right: 40, bottom: 40, left: 50},
      duration = 400,
      displayValues = false,
      tip,
      redLines,
      decimals,
      maxAxisValue,
      sumTip;

    var chart = function (selection) {
      selection.each(function (data) {
        var keyDigits = d3.max(data.map(function (d) {
          return accessor('key')(d).length;
        }));

        margin.left = 10 + 13 * keyDigits;

        var xFormatter = germanNumberFormat(',.' + decimals + '%');
        var xAxisFormatter = decimals ? xFormatter : germanNumberFormat("%");
        var getLabelBy = function (property, d, featureData) {
          return d.prefix + ((d.unit === '%') ? xFormatter(d[property] / 100) : (germanNumberFormat(',.' + decimals + 'f')(d[property]) + ' (' + xFormatter(d[property] / featureData.sum) + ')'));
        }

        var container = d3.select(this).datum([data]).classed('horizontal-stacked-set-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }
        if (angular.isDefined(sumTip)) {
          sumTip.destroy();
        }

        sumTip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            var featureData = values[j].parentNode.parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + getLabelBy('sum', d, featureData) + '</span></div>';
          });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            var featureData = values[j].parentNode.parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + getLabelBy('value', d, featureData) + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('.margin-group').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var featureScale = d3.scale.ordinal()
          .rangeRoundBands([0, height], 0.3)
          .domain(data.map(accessor('key')));

        var barScale = d3.scale.linear()
          .domain([0, 1])
          .range([0, width]);

        var tickCount = Math.min(svgWidth / 90, 10);

        var xAxis = d3.svg.axis()
          .scale(barScale)
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicators[0].prefix + xAxisFormatter(d).replace('%', '');
          })
          .orient('bottom');

        var yAxis = d3.svg.axis()
          .scale(featureScale)
          .orient('left');
        redLines = redLines ? redLines : mapConfig.redLines;
        var lineScale = d3.scale.linear()
          .domain([0, maxAxisValue ? maxAxisValue : 100])
          .range([0, width]);

        g.call(d3.hyperion.addVerticalGridLines(barScale, height, 0, tickCount, duration));
        g.call(d3.hyperion.addVerticalHighlightArea(redLines, featureScale, lineScale, height, duration));

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .transition().duration(duration)
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis);

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'middle')
          .attr('dominant-baseline', 'initial')
          .attr('transform', 'translate(' + (width / 2 + margin.left) + ',' + (height + margin.top + margin.bottom) + ')')
          .text('in %');

        var features = g.selectAll('.feature')
          .data(data, accessor('key'));

        features.enter()
          .append('g')
          .classed('feature', true)
          .attr('transform', function (d) {
            return 'translate(0,' + featureScale(accessor('key')(d)) + ')';
          });

        features
          .transition().duration(duration)
          .attr('transform', function (d) {
            return 'translate(0,' + featureScale(accessor('key')(d)) + ')';
          });

        features.exit().remove();

        var lists = features.selectAll('.list')
          .data(accessor('listValues'), accessor('uid'));

        lists
          .enter()
          .append('g')
          .attr('class', 'list')
          .attr('transform', 'translate(0,0)');

        lists.transition().duration(duration)
          .attr('transform', function (d, i, j) {
            if (d.unit === '%') {
              return 'translate(' + barScale(d.offset / 100) + ',0)';
            } else {
              return 'translate(' + barScale(d.offset / lists[j].parentNode.__data__.sum) + ',0)';
            }
          });

        lists.exit().remove();

        var sumBars = lists.selectAll('.sum')
          .data(function (d) {
            return [{
              sum: d.sum,
              color: d.color,
              name: d.name,
              isList: d.isList,
              unit: d.unit,
              prefix: d.prefix,
              key: d.key,
              idx: d.legendIndex
            }];
          });

        sumBars.enter()
          .append('rect')
          .attr('class', function (d) {
            return 'sum focus-bar_' + d.idx + (d.isList ? '' : ' sum__' + d.key);
          })
          .classed('sum-only', function (d) {
            return !d.isList;
          })
          .attr('x', 0)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('width', 0)
          .attr('height', featureScale.rangeBand());

        sumBars.classed('sum-only', function (d) {
          return !d.isList;
        })
          .transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', featureScale.rangeBand())
          .attr('width', function (d, i, j) {
            // fetch sum from feature for scaling the sum
            return d.unit === '%' ? barScale(d.sum / 100) : barScale(d.sum / sumBars[j].parentNode.parentNode.__data__.sum); // do not auto-expand to full width
            //return barScale(d.sum / sumBars[j].parentNode.parentNode.__data__.sum);
          });

        sumBars.exit().remove();

        var sumOnly = lists.selectAll('.sum-only');
        if (sumOnly.size() > 0) {
          sumOnly.call(sumTip);
          lists.selectAll('.sum-only').on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              sumTip.show(d, i, j);
            }
          })
            .on('mouseout', function (d) {
              if (d.color.toLowerCase() !== '#ffffff') {
                sumTip.hide(d);
              }
            });
        }

        var values = lists.selectAll('.value')
          .data(accessor('values'));

        values.enter()
          .append('rect')
          .attr('class', 'value')
          .attr('x', 0)
          .attr('width', 0)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', featureScale.rangeBand());

        values.transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('class', function (d) {
            return "value " + d.key + ' focus-bar_' + d.legendIndex;
          })
          .attr('x', function (d, i, j) {
            if (d.offset === 0) return 0;
            return d.unit === '%' ? barScale(d.offset / 100) : barScale(d.offset / values[j].parentNode.parentNode.__data__.sum); // do not auto-expand to full width
            //return barScale(d.offset / values[j].parentNode.parentNode.__data__.sum);
          })
          .attr('width', function (d, i, j) {
            if (d.value === 0) return 0;
            return d.unit === '%' ? barScale(d.value / 100) : barScale(d.value / values[j].parentNode.parentNode.__data__.sum); // do not auto-expand to full width
            //return barScale(d.value / values[j].parentNode.parentNode.__data__.sum);
          })
          .attr('height', featureScale.rangeBand());

        values.exit().remove();

        if (values.size() > 0) {
          values.call(tip);
          values.on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.show(d, i, j);
            }
          })
            .on('mouseout', function (d) {
              if (d.color.toLowerCase() !== '#ffffff') {
                tip.hide(d);
              }
            });
        }

        var labels = lists.selectAll('text.value-label')
          .data(accessor('values'));
        //.data(function (d) {
        //  return [{sum: d.sum, color: d.color, name: d.name, isList: d.isList, unit: d.unit, prefix: d.prefix}];
        //});

        g.selectAll('line.highlightLine').remove();
        g.call(d3.hyperion.addVerticalHighlightLines(redLines, lineScale, height, duration));

        labels.enter()
          .append('text')
          .attr('x', 0);

        // update labels
        labels
          .attr('class', function (d) {
            return "value-label horizontal " + d.key + ' focus-bar_' + d.legendIndex;
          })
          .text(function (d, i, j) {
            //return germanNumberFormat('.' + decimals + 'f')(accessor('value')(d));
            var featureData = values[j].parentNode.parentNode.__data__;
            return getLabelBy('value', d, featureData);
            //return d.prefix + ((d.unit === '%') ? xFormatter(d.value / 100) : (germanNumberFormat(',.' + decimals + 'f')(d.value) + ' (' + xFormatter(d.value / featureData.sum) + ')'))
          })
          .attr('x', function (d, i, j) {
            //console.log(d,i,j);
            if (d.value === 0) return 0;
            var labelX = displayValues ? d.offset + d.value : d.value;
            return d.unit === '%' ? barScale(labelX / 100) : barScale(labelX / values[j].parentNode.parentNode.__data__.sum); // do not auto-expand to full width
          })
          .attr('y', function (d, i) {
            return (featureScale.rangeBand() / 2);
          })
          .attr('dx', 4)
          .attr('dy', 4);

        // remove unused labels
        labels.exit()
          .remove();

        var sumLabels = lists.selectAll('text.sum-label')
          .data(function (d) {
            return [{
              sum: d.sum,
              color: d.color,
              name: d.name,
              isList: d.isList,
              unit: d.unit,
              prefix: d.prefix,
              idx: d.legendIndex
            }];
          });

        sumLabels.enter()
          .append('text')
          .attr('x', 0);

        // update labels
        sumLabels
          .attr('class', function (d) {
            return "sum-label horizontal " + " focus-bar_" + d.idx;
          })
          .attr('x', function (d, i, j) {
            if (displayValues) return 0;
            return d.unit === '%' ? barScale(d.sum / 100) : barScale(d.sum / sumBars[j].parentNode.parentNode.__data__.sum);
          })
          .text(function (d, i, j) {
            var sumValue = accessor('sum')(d);
            if (sumValue !== 0) {
              var featureData = values[j].parentNode.parentNode.__data__;
              return getLabelBy('sum', d, featureData);
              //return d.prefix + ((d.unit === '%') ? xFormatter(d.sum / 100) : (germanNumberFormat(',.' + decimals + 'f')(d.sum) + ' (' + xFormatter(d.sum / featureData.sum) + ')'))
              //return germanNumberFormat('.' + decimals + 'f')(accessor('sum')(d));
            } else {
              return '';
            }

          })
          .attr('y', function (d, i) {
            return (featureScale.rangeBand() / 2);
          })
          .attr('dx', 4)
          .attr('dy', 4);
        // remove unused labels
        sumLabels.exit()
          .remove();
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    var content = element.closest('.grid-stack-item-content-horizontalStackedSetBarChart');
    return content.height() - jQuery(content).find('.selected-indicator-set').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'horizontalStackedSetBarChart.html',
    scope: {
      layer: '=',
      indicators: '=',
      colorsets: '=',
      indicatorSets: '=',
      disabledDistrictKeys: '=',
      disabledListIndex: '=',
      dimensionX: '@',
      dimensionY: '@',
      mouseOverFeature: '=',
      config: '='
    },
    link: function (scope, element) {
      scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;
      scope.disabledListIndex = scope.disabledListIndex || [];

      var horizontalStackedSetBarChartFunction = horizontalStackedSetBarChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }

        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators;
        var redLines = null,
          decimals,
          maxAxisValue;

        scope.selectedIndicatorSet = [];
        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function (color) {
                return color.color;
              });
              legend = scope.layer.legend[defaultIndicatorUid];

              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }
              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }
              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }
            }

            if (!decimals) {
              decimals = scope.selectedIndicatorSet.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            var data = combineData(scope.layer, scope.selectedIndicatorSet, scope.disabledDistrictKeys, scope.disabledListIndex, colorset, legend);

            horizontalStackedSetBarChartFunction
              .indicators(indicators)
              .displayValues(scope.config.displayValues)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .height(newHeight);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data])
              .call(horizontalStackedSetBarChartFunction);
          } else {
            scope.config.selectedIndicatorSet = null;
            d3.select(element[0]).select('svg').remove();
          }
        }
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var colorsetsWatcher = scope.$watchCollection('colorsets', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var disabledListIndexWatcher = scope.$watch('disabledListIndex', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        colorsetsWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        disabledListIndexWatcher();
        // remove tooltip dom element
        if (angular.isDefined(horizontalStackedSetBarChartFunction.tip())) {
          horizontalStackedSetBarChartFunction.tip().destroy();
        }
      });
    }
  };
});
